import { NgModule }              from '@angular/core';
import { UIRouterUpgradeModule } from '@uirouter/angular-hybrid';

import { PodiumService }           from './podium.service';
import { PodiumSettingsComponent } from './podium.settings.component';
import { PodiumStates }            from './podium.states';
import { SharedModule }            from '../shared/shared.module';

@NgModule({
  declarations: [
    PodiumSettingsComponent
  ],
  entryComponents: [
    PodiumSettingsComponent
  ],
  exports: [
    PodiumSettingsComponent
  ],
  imports: [
    SharedModule,

    UIRouterUpgradeModule.forChild({ states: PodiumStates })
  ],
  providers: [
    PodiumService
  ]
})
export class PodiumModule {}
